type StockProductRowProps = {
  productName: string;
  classification: string;
  quantity: number;
};

/** Linha de bolão nos modais de estoque: número em destaque, tipo e quantidade de cotas. */
export const StockProductRow = ({
  productName,
  classification,
  quantity,
}: StockProductRowProps) => (
  <div className="flex items-center justify-between gap-3 rounded-lg border bg-background px-3 py-2.5">
    <div className="flex items-center gap-3 min-w-0">
      <span className="rounded-md bg-primary px-2.5 py-1 text-sm font-bold text-primary-foreground">
        {productName}
      </span>
      <span className="text-sm text-muted-foreground truncate">
        {classification}
      </span>
    </div>
    <div className="shrink-0 text-right">
      <span className="text-xl font-bold leading-none">{quantity}</span>
      <span className="ml-1 text-xs text-muted-foreground">
        {quantity === 1 ? "cota" : "cotas"}
      </span>
    </div>
  </div>
);
